var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FEEBEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 17,
    fill: "#FBC1C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 33.3327C20.3975 33.3327 16.6665 29.6017 16.6665 24.9993C16.6665 20.397 20.3975 16.666 24.9998 16.666C29.6022 16.666 33.3332 20.397 33.3332 24.9993C33.3332 29.6017 29.6022 33.3327 24.9998 33.3327ZM24.1665 27.4993V29.166H25.8332V27.4993H24.1665ZM24.1665 20.8327V25.8327H25.8332V20.8327H24.1665Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.54f66dc385a2c7cad520a0f81bbb952f.svg";
export { ForwardRef as ReactComponent };